import { sessionApiClient } from "@planningcenter/cc-api-client"
import { unlessCommonError } from "source/CommonErrorBoundary"
import type { ApiClient, SingularAPIResponse } from "source/shared/types"
import type { PageAPIRecord } from "source/publishing/WebBoot/types"

export function pageQuery(
  slug: string,
  version: "draft" | "published",
  { apiClient = sessionApiClient }: { apiClient?: ApiClient } = {},
) {
  const path = `/publishing/v2/pages/${slug}@${version}`

  return {
    queryKey: [path],
    queryFn: () =>
      apiClient.get(path) as Promise<SingularAPIResponse<PageAPIRecord>>,
    retry: unlessCommonError,
  }
}
